
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getMailSenderSmtpSettingsDtoFormGroup() {
return new FormGroup({
    isConfigured: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    missingSettings: new FormControl<Array<string> | undefined>([], [Validators.required]),
    host: new FormControl<string | undefined>(undefined),
    port: new FormControl<number | undefined>(undefined),
    username: new FormControl<string | undefined>(undefined),
    passwordConfigured: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    useTls: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
})
;
}
      